#patch-management-general-content {
  width: 70%;

  #patch-management-general-info-text {
    color: var(--body-text-arrows-400);
  }
}
